















































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { VueEasyJwt } from 'vue-easy-jwt';
import { UserActions } from '@/modules/users/store/user.actions';
import { user } from '@/modules/shared/shared/store/namespaces';
import { UserGetters } from '@/modules/users/store/user.getters';
import { Customer } from '@/modules/customers/domain/customer';
import { RecoveryPasswordRequest } from '@/modules/users/domain/recovery-password-request';
import { LoginRequest } from '@/modules/users/domain/login-request';
import { UserMutations } from '@/modules/users/store/user.mutations';
const jwt = new VueEasyJwt();

@Component({
    name: 'login',
})
export default class Login extends Vue {
    recoveryMail: string = '';
    valid: boolean = false;
    loadingForm: boolean = false;
    loadingSendEmailButton: boolean = false;
    snackbarError: boolean = false;
    changedUsername: boolean = false;
    snackbarText: string = '';
    snackbarColor: string = '';
    timeout: number = 5000;
    windowIndex: number = 1;
    windowKey: number = 1;
    clientId: number = -1;
    email: string = '';
    emailRules: any[] = [(v: any) => !!v || 'Requerido'];
    show: boolean = false;
    password: string = '';
    version: string = '[NOT SET]';
    rules: {} = {
        required: (value: string) =>
            (!!value && value !== '' && value !== undefined) || 'Requerido',
    };

    mounted() {
        const preloader = document.getElementById('app-preloader');

        if (preloader) {
            preloader.style.display = 'none';
        }
        this.clearClient();
    }

    async sendEmail() {
        this.loadingSendEmailButton = true;
        if (await this.validateUsername(true)) {
            // valid user
            if (this.customerOptions instanceof Array) {
                // multiple customers
                if (this.clientId == -1) {
                    this.clientId = this.customerOptions[0].id;
                    this.loadingSendEmailButton = false;
                    return; // select / confirm customer
                }
            } else {
                // single customer
                this.clientId = this.customerOptions.id;
            }

            let recoveryPasswordRequest: RecoveryPasswordRequest = {
                username: this.email,
                customer: this.clientId !== -1 ? this.clientId : null,
            };

            const failed = await this.recoveryPassword(recoveryPasswordRequest);

            this.changeWindow(1);

            if (!failed) {
                this.openSnackbar(
                    `Los pasos correspondientes para restablecer su contraseña fueron enviados al correo electrónico: ${this.email}`,
                    'green',
                );
            } else {
                this.openSnackbar('Ocurrió un error, por favor intente de nuevo', 'error');
            }
        }

        this.loadingSendEmailButton = false;
    }

    async validate() {
        if (this.valid && this.$refs.form1.validate() && this.email && this.password) {
            this.loadingForm = true;
            let user: LoginRequest;
            if (await this.validateUsername()) {
                // username was correct

                if (this.customerOptions instanceof Array) {
                    // multiple customers
                    if (this.clientId == -1) {
                        this.clientId = this.customerOptions[0].id;
                        this.loadingForm = false;
                        return; // select / confirm customer
                    }
                } else {
                    // single customer
                    this.clientId = this.customerOptions.id;
                }

                if (this.clientId && this.clientId !== -1) {
                    user = {
                        username: this.email,
                        password: this.password,
                        customer: this.clientId,
                    };
                } else {
                    user = {
                        username: this.email,
                        password: this.password,
                    };
                }

                const failed = await this.login(user);

                if (!failed) {
                    if (this.userHasPrivilegesOverFeedbacks) {
                        await this.$router.push({ name: 'feedbacks' });
                    } else {
                        await this.$router.push({ name: 'tickets' });
                    }
                } else {
                    this.openSnackbar(
                        'Verifique sus datos para iniciar sesión, por favor intente de nuevo',
                        'error',
                    );
                }

                this.loadingForm = false;
            }
        } else {
            this.openSnackbar(
                'Verifique sus datos para iniciar sesión, por favor intente de nuevo',
                'error',
            );
        }
        this.loadingForm = false;
    }

    async validateUsername(ignoreForm = false) {
        if ((ignoreForm || (this.$refs.form1.validate() && this.valid)) && this.email) {
            const failed = await this.lookUp(this.email);
            if (failed) {
                this.openSnackbar(
                    'Nombre de usuario incorrecto, por favor verifique sus datos e intente de nuevo',
                    'error',
                );
            } else {
                return true;
            }
            return false;
        }
    }

    $refs!: {
        form1: any;
        form2: any;
    };

    openSnackbar(message: string, color: string) {
        this.closeSnackbar();
        this.snackbarText = message;
        this.snackbarColor = color;
        this.snackbarError = true;
    }

    closeSnackbar() {
        this.snackbarError = false;
        this.snackbarText = '';
    }

    changeWindow(windowIndex: number) {
        if (windowIndex !== 1 || !this.loadingForm) {
            this.windowIndex = windowIndex;
        }

        if (windowIndex === 1 && !this.loadingForm) {
            this.password = '';
            this.clientId = -1;
            this.windowKey = this.windowKey === 1 ? 0 : 1;
            this.windowKey = this.windowKey === 1 ? 0 : 1;
        }
    }

    beforeCreate() {
        const yourToken: any = localStorage.getItem('token');
        if (!jwt.isExpired(yourToken)) {
            if (this.userHasPrivilegesOverFeedbacks) {
                this.$router.push({ name: 'feedbacks' });
            } else {
                this.$router.push({ name: 'tickets' });
            }
        }
    }

    clearClient() {
        this.clientId = -1;
        this.setCustomersOptions({});
    }

    @user.Action(UserActions.LOOK_UP) lookUp!: (username: string) => Promise<RequestResponse>;
    @user.Action(UserActions.RECOVERY_PASSWORD) recoveryPassword!: (
        recoveryPasswordRequest: RecoveryPasswordRequest,
    ) => Promise<RequestResponse>;
    @user.Action(UserActions.LOGIN) login!: (
        loginRequest: LoginRequest,
    ) => Promise<RequestResponse>;

    @user.Getter(UserGetters.HAS_PRIVILEGES_OVER_FEEDBACKS)
    userHasPrivilegesOverFeedbacks!: boolean;
    @user.Getter(UserGetters.GET_CUSTOMER_OPTIONS) customerOptions!: Customer[] | { id: number };
    @user.Mutation(UserMutations.SET_CUSTOMER_OPTIONS)
    setCustomersOptions!: (options: {}) => void;
}
